import moment from "moment";

export const SalesEncRow = function () {
  this.species = null;
  this.dealer_permit_number = null;
  this.sold = null;
  this.date_sold = null;
  this.offloading_port = null;
  this.uom = null;
  this.dealer_name = null;
  this.price_per_bushel = null;
  this.allocation_numbers = [];
  this.tag_numbers = [];
};
SalesEncRow.prototype.setSpecies = function (species) {
  this.species = species;
};
SalesEncRow.prototype.setDealerPermitNumber = function (dealer_permit_number) {
  this.dealer_permit_number = dealer_permit_number;
};
SalesEncRow.prototype.setSold = function (sold) {
  this.sold = sold;
};
SalesEncRow.prototype.setDateSold = function (date_sold) {
  this.date_sold = date_sold;
};
SalesEncRow.prototype.setOffLoadingPort = function (offloading_port) {
  this.offloading_port = offloading_port;
};
SalesEncRow.prototype.setUom = function (uom) {
  this.uom = uom;
};
SalesEncRow.prototype.setDealerName = function (dealer_name) {
  this.dealer_name = dealer_name;
};
SalesEncRow.prototype.setPricePerBushel = function (price_per_bushel) {
  this.price_per_bushel = price_per_bushel;
};
SalesEncRow.prototype.setAllocationNumbers = function (allocation_numbers) {
  this.allocation_numbers = allocation_numbers;
};
SalesEncRow.prototype.setTagNumbers = function (tag_numbers) {
  this.tag_numbers = tag_numbers;
};

export const SalesCombinedEncRow = function () {
  this.species = null;
  this.species_label = null;
  this.total_available = null;
  this.original_available = null;
  this.available = null;
  this.total_sold = null;
  this.original_sold = null;
  this.sold = null;
  this.catch_uom = null;
  this.sales_uom = null;
};
SalesCombinedEncRow.prototype.setSpecies = function (species) {
  this.species = species;
};
SalesCombinedEncRow.prototype.setSpeciesLabel = function (species_label) {
  this.species_label = species_label;
};

SalesCombinedEncRow.prototype.setTotalAvailable = function (total_available) {
  this.total_available = total_available;
};
SalesCombinedEncRow.prototype.setOriginalAvailable = function (original_available) {
  this.original_available = original_available;
};
SalesCombinedEncRow.prototype.setTotalSold = function (total_sold) {
  this.total_sold = total_sold;
};
SalesCombinedEncRow.prototype.setOriginalSold = function (original_sold) {
  this.original_sold = original_sold;
};
SalesCombinedEncRow.prototype.setAvailable = function (available) {
  this.available = available;
};
SalesCombinedEncRow.prototype.setSold = function (sold) {
  this.sold = sold;
};

SalesCombinedEncRow.prototype.setCatchUom = function (catch_uom) {
  this.catch_uom = catch_uom;
};
SalesCombinedEncRow.prototype.setSalesUom = function (sales_uom) {
  this.sales_uom = sales_uom;
};

export const DateSoldNowHandler = function (event) {
  event.preventDefault();
  let d = moment();
  const format = "DD-MMM-YY";
  let newState = {};
  newState.date_sold = d.format("YYMMDD");
  newState.display_date_sold = d.format(format);
  this.setState(newState);
};

export const dateSoldHandler = function (date) {
  if (date && date.hasOwnProperty("_d")) {
    let newDateTime = date._d;
    if (newDateTime !== "") {
      const dt = moment(newDateTime, "DD-MM-YYYY");
      let bDateTime = dt.format("YYMMDD");
      this.setState({
        display_date_sold: newDateTime,
        date_sold: bDateTime,
      });
    } else {
      this.setState({ display_date_sold: newDateTime, date_sold: "" });
    }
  } else {
    this.setState({ display_date_sold: "", date_sold: "" })
  }
};
export const handleDealerPreferenceChange = function (event) {
  event.preventDefault();
  console.info("handleDealerPreferenceChange", event.currentTarget.dataset);
  let dealerName = event.currentTarget.dataset.dealer_name;
  let dealerPermitNumber = event.currentTarget.dataset.dealer_permit_number;
  if (!dealerPermitNumber) {
    console.log("No new dealer permit number provided");
    return;
  }
  if (!dealerName) {
    console.log("No new dealer name provided");
    return;
  }

  let newState = {};
  newState.dealer_name = dealerName;
  newState.dealer_permit_number = dealerPermitNumber;
  console.info("prefchange", newState);
  this.setState(newState);
};

export const dealerChangeHandler = function (event, reason) {
  if (reason) {
    //Save the new values when selected
    if (
      reason.hasOwnProperty("DEALER_PERMIT_NUMBER") &&
      reason.hasOwnProperty("DEALER_NAME")
    ) {
      this.setState({
        dealer_permit_number: reason.DEALER_PERMIT_NUMBER,
        dealer_name: reason.DEALER_NAME,
      });
    }
  } else {
    //If emptied then empty the state
    this.setState({
      dealer_permit_number: "",
      dealer_name: "",
    });
  }
};

export const handlePortPreferenceChange = function (event) {
  event.preventDefault();
  console.info("handlePortPreferenceChange", event.currentTarget.dataset);

  let portId = event.currentTarget.dataset.port_id;
  let portName = event.currentTarget.dataset.port_name;
  let portState = event.currentTarget.dataset.port_state;
  let portCity = event.currentTarget.dataset.port_city;
  if (!portId) {
    console.log("No new port id provided");
    return;
  }
  if (!portName) {
    console.log("No port name provided");
    return;
  }
  if (!portState) {
    console.log("No port state provided");
    return;
  }
  if (!portCity) {
    console.log("No port city provided");
    return;
  }

  let newState = {};
  newState.port_name = portName;
  newState.offloading_port = portId;
  newState.port_city = portCity;
  newState.port_state = portState;
  console.info("prefchange", newState);
  this.setState(newState);
};

export const portChangeHandler = function (event, reason) {
  if (reason) {
    if (
      reason.hasOwnProperty("NAME") &&
      reason.hasOwnProperty("CITY") &&
      reason.hasOwnProperty("STATE") &&
      reason.hasOwnProperty("ID")
    ) {
      this.setState({
        offloading_port: reason.ID,
        port_name: reason.NAME,
        port_state: reason.STATE,
        port_city: reason.CITY,
      });
    }
  } else {
    //If emptied then empty the state
    this.setState({
      offloading_port: "",
      port_name: "",
      port_state: "",
      port_city: "",
    });
  }
};

export const getPortDisplay = function (port_id, portList) {
  let port_display = null;
  if (!port_id || !Array.isArray(portList)) {
    return port_display;
  }
  for (let f = 0; f < portList.length; f++) {
    if (port_id === portList[f].ID) {
      port_display = portList[f].ID + " - " + portList[f].NAME + "," + portList[f].STATE;
      break;
    }
  }
  return port_display;
};

export const getSalesRow = function (salesObject) {
  let s = new SalesEncRow();
  s.setSpecies(salesObject.species);
  s.setDealerPermitNumber(salesObject.dealer_permit_number);
  s.setDealerName(salesObject.dealer_name);
  s.setSold(salesObject.sold);
  s.setDateSold(salesObject.date_sold);
  s.setOffLoadingPort(salesObject.offloading_port);
  s.setUom(salesObject.uom);
  s.setPricePerBushel(salesObject.price_per_bushel);
  s.setAllocationNumbers(salesObject.allocation_numbers);
  s.setTagNumbers(salesObject.tag_numbers);
  return s;
};
